import { Button } from "antd";
import React, { ReactNode, useState } from "react";
import * as XLSX from "xlsx";

export const UploadCsv = (props: {
  button: string | ReactNode;
  validate?: (file) => boolean;
  onFinish: (data, file) => void;
}) => {
  const inputFileRef = React.useRef(null);
  const [file, setFile] = useState(null);

  const uploadFile = (e) => {
    let file = e.target.files[0];

    if (props.validate && !props.validate(file)) {
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const workbook = XLSX.read(reader.result, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      setFile(file);
      props.onFinish(data, file);
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div>
      <Button onClick={() => inputFileRef.current.click()}>
        {props.button}
      </Button>
      <input
        style={{ display: "none" }}
        type="file"
        name="myFile"
        ref={inputFileRef}
        accept=".xlsx,.xls"
        onChange={uploadFile}
      />

      {file && <span>&nbsp;{file.name}</span>}
    </div>
  );
};
